/// <amd-module name="Feed/Legacy/DataServices/UpstreamBehaviorService" />
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

import { Package } from "Feed/Common/Contracts/Feed";
import { UpstreamingBehavior } from "Feed/Common/Protocols/Shared/Contracts/PackagingShared";
import { IFeedProtocolProvider } from "Feed/Legacy/Protocols/ProtocolProvider";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export interface IUpstreamBehaviorService extends IVssService {
    getUpstreamBehaviorAsync(feed: Feed, pkg: Package): Promise<UpstreamingBehavior>;
    setUpstreamBehaviorAsync(d: Feed, pkg: Package, behavior: UpstreamingBehavior): Promise<void>;
}

export class UpstreamBehaviorService extends VssService implements IUpstreamBehaviorService {
    public _serviceStart(pageContext: IVssPageContext) {
        this.protocolProvider = pageContext.getService<IFeedProtocolProvider>("IFeedProtocolProvider");
    }

    public async getUpstreamBehaviorAsync(feed: Feed, pkg: Package): Promise<UpstreamingBehavior> {
        let promise = this.cache[pkg.id];
        if (!promise) {
            const protocol = this.protocolProvider.get(pkg.protocolType);
            const project = feed.project && feed.project.id;
            this.cache[pkg.id] = promise = protocol.getUpstreamingBehavior(feed, pkg);
        }
        return promise;
    }

    public async setUpstreamBehaviorAsync(feed: Feed, pkg: Package, behavior: UpstreamingBehavior): Promise<void> {
        const project = feed.project && feed.project.id;
        const protocol = this.protocolProvider.get(pkg.protocolType);
        await protocol.setUpstreamingBehavior(feed, pkg, behavior);
        delete this.cache[pkg.id];
    }

    private cache: { [key: string]: Promise<UpstreamingBehavior> } = {};
    private protocolProvider: IFeedProtocolProvider;
}

Services.add("IUpstreamBehaviorService", { serviceFactory: UpstreamBehaviorService });
